export default "__VITE_ASSET__Di1pkvWv__"